export default __webpack_public_path__ + "static/media/2.f70294de.png";